import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityApiService } from '../shared/services/identity-api.service';
import { PASSWORD_PATTERN } from '../shared/utils/password-validation';

@Component({
  selector: 'ins-reset-password',
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  errorMessage = '';
  private token = '';
  private userId = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private identityApi: IdentityApiService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      password: [
        '',
        [Validators.required, Validators.pattern(PASSWORD_PATTERN)],
      ],
      confirmPassword: ['', Validators.required],
    });

    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (this.token) {
      try {
        const payload = JSON.parse(atob(this.token.split('.')[1]));
        this.userId = payload.systemid || '';
      } catch {
        this.errorMessage =
          'Your reset link is invalid or expired. Please request a new password reset.';
      }
    }
  }

  get passwordMismatch(): boolean {
    return (
      this.form.controls['password'].value !==
        this.form.controls['confirmPassword'].value &&
      this.form.controls['confirmPassword'].touched
    );
  }

  onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.passwordMismatch) {
      return;
    }

    if (!this.token || !this.userId) {
      this.errorMessage =
        'Your reset link is invalid or expired. Please request a new password reset.';
      return;
    }

    this.errorMessage = '';
    const newPassword = this.form.controls['password'].value;

    this.identityApi
      .resetPassword(this.userId, this.token, newPassword)
      .subscribe({
        next: () => {
          this.submitted = true;
          setTimeout(() => this.router.navigate(['/login']), 10000);
        },
        error: () => {
          this.errorMessage =
            'There was an issue resetting your password. Your link may be expired. ' +
            'Please try resetting your password again.';
        },
      });
  }
}
